import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarchiComponent } from './marchi.component';
import { MarchiListComponent } from './marchi-list/marchi-list.component';
import { MarchiRoutingModule } from './marchi-routing.module';
import { MarchiDetailsComponent } from './marchi-details/marchi-details.component';
import { MarchiEditComponent } from './marchi-edit/marchi-edit.component';
import { MarchiCreateComponent } from './marchi-create/marchi-create.component';
import { FormsModule } from '@angular/forms';


//import { PipeCustomModule } from '../shared/pipe-custom/pipe-custom.module';
import { MarchiSharedModule } from './marchi-shared/marchi-shared.module';
import { MarchiListBlobsComponent } from './marchi-list-blobs/marchi-list-blobs.component';

import { MarchiListPdfComponent } from './marchi-list-pdf/marchi-list-pdf.component';
import { PipeCustomModule } from 'my-lib-sanfelici';
import { MyCustomMaterialModule } from 'san-common';




@NgModule({
  imports: [
      CommonModule,
      MarchiRoutingModule,
      MyCustomMaterialModule,
      FormsModule,
            PipeCustomModule,MarchiSharedModule
  ],
  declarations: [
    MarchiComponent,
     MarchiListComponent,
     MarchiCreateComponent,
     MarchiDetailsComponent,
     MarchiEditComponent,
     MarchiListBlobsComponent,MarchiListPdfComponent
  ], exports: [
    MarchiListComponent,
    MarchiCreateComponent,
    MarchiDetailsComponent,
    MarchiEditComponent,
    MarchiListBlobsComponent,MarchiListPdfComponent
  ],
  providers: []
})
export class MarchiModule { }
